import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { SectionHead, Reveal } from "../Reveal";
import { FAQS } from "../../data/site";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="relative py-20 sm:py-28">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHead
        eyebrow="FAQ"
        title={
          <>
            Questions? <span className="text-gradient-orange">Answered.</span>
          </>
        }
      />
      <Reveal>
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-xl border border-sky-500/20 bg-[#0B1226] px-6 data-[state=open]:border-orange-500/50 transition-colors duration-300"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="font-display text-base font-semibold text-white hover:text-orange-400 hover:no-underline py-5"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-slate-400 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
